export default __webpack_public_path__ + "static/media/sc-mail-active-ico.f87d9447.svg";